import { authorizedFetch } from '../../../utils/api';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE = `${API_BASE_URL}/v2/admin/ocr`;

export const ocrApi = {
    health: () => authorizedFetch(`${BASE}/health`),

    createTask: async (file, params = {}) => {
        const fd = new FormData();
        fd.append('file', file);
        Object.entries(params).forEach(([k, v]) => {
            if (v !== null && v !== undefined) fd.append(k, String(v));
        });
        return authorizedFetch(`${BASE}/tasks/create`, {
            method: 'POST',
            body: fd,
        });
    },

    createBatch: async (files, params = {}) => {
        const fd = new FormData();
        files.forEach(f => fd.append('files', f));
        Object.entries(params).forEach(([k, v]) => {
            if (v !== null && v !== undefined) fd.append(k, String(v));
        });
        return authorizedFetch(`${BASE}/tasks/batch/create`, {
            method: 'POST',
            body: fd,
        });
    },

    batchStatus: (taskIds) =>
        authorizedFetch(`${BASE}/tasks/batch`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ taskIds }),
        }),

    taskDetail: (taskId) =>
        authorizedFetch(`${BASE}/tasks/${taskId}/detail`),

    taskMarkdown: (taskId) =>
        authorizedFetch(`${BASE}/tasks/${taskId}/markdown`),

    taskLayoutText: async (taskId) => {
        const resp = await authorizedFetch(`${BASE}/tasks/${taskId}/layout-text`);
        return resp?.text ? await resp.text() : (typeof resp === 'string' ? resp : '');
    },

    cacheStats: () =>
        authorizedFetch(`${BASE}/cache/stats`),

    monitor: () =>
        authorizedFetch(`${BASE}/monitor`),

    cacheClear: (pattern = null) =>
        authorizedFetch(`${BASE}/cache/clear`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pattern ? { pattern } : {}),
        }),
};
